import React, {useEffect, useState} from 'react';
import { getPractices } from './services/onwardReferralService';

const FacilityName = ({api, facilityName, setFacilityName,opmOverrideSearch,caseID,PatientID, searchFromHome,
    searchFromWork}) => {
    const [clinicList, setClinicList] = useState([])
    
    const facilityNameHandler = (e) => {
        setFacilityName(e.target.value);
    }

    const clinicListHandler = (clinicNamesInApiResult) => {
        let clinicNames = []
        if(clinicNamesInApiResult !== 0){
            clinicNames = clinicNamesInApiResult.map((clinic, index)=>{
                console.log(clinic.FacilityName)
                return <option key={clinic + index} value={clinic.FacilityName}>{clinic.FacilityName}</option>
            })
        }
        return clinicNames
    }

useEffect(() => {
    const minLength = opmOverrideSearch ? 3 : 2;

    if (facilityName.length >= minLength) {
        const params = {
            FacilityName: facilityName,
            CaseID: caseID,
            PatientID: PatientID,
            ...(opmOverrideSearch && { OPMOverride: true }),
             ...(searchFromHome !== undefined && { SearchFromHome: searchFromHome.toString() }),
                ...(searchFromWork !== undefined && { SearchFromWork: searchFromWork.toString() }),
        };

        getPractices(api, params)
            .then(r => {
                setClinicList(clinicListHandler(r));
            })
            .catch(e => {
                console.log(e);
            });
    }
}, [facilityName, opmOverrideSearch, api,caseID, PatientID]);

    return (
        <>
            <label>
                <div>
                    <div>
                        Clinic Name
                    </div>
                    <div >
                        <input 
                            className="SearchTextInputFullSize" 
                            type="text"
                            list="facilityNameList"
                            value={facilityName}
                            onChange={facilityNameHandler}
                        />
                        <datalist id="facilityNameList">
                            {clinicList.map(r=>{
                                return r
                            })}
                        </datalist>
                    </div>
                </div>
            </label>
        </>
    )
}

export default FacilityName